<template>
    <cv-modal :visible.sync="visible" @check="hide" @hide="clear" noncancelable checkBtn="关闭" c="modal default large" class="warning" :title="'产品预警 - ' + product.name">
        <!-- 预警历史 -->
        <section v-if="$root.hasPermission(permissions.financing.product.warning.show)" v-show="warnings.length > 0" class="section">
            <div class="head">
                <span class="title">预警</span>
                <span class="operation">
                    <cv-button v-if="!isMoreWarning" @click="moreWarning" c="link primary mini underline">更多</cv-button>
                    <cv-button v-else @click="normalWarning" c="link primary mini underline">收起</cv-button>
                </span>
            </div>
            
            <cv-form :labelWidth="0" c="form primary medium distant-y">
                <div class="table-container">
                    <cv-table :data="visibleWarnings" c="table custom medium">
                        <template v-slot="scope">
                            <cv-table-column label="#" width="3em" :scope="scope">{{scope.index+1}}</cv-table-column>
                            <cv-table-column label="规则名称" width="15em" :scope="scope">
                                <template v-if="scope.row.warningRule">
                                    {{scope.row.warningRule.name}}
                                </template>
                            </cv-table-column>
                            <cv-table-column label="规则" width="20em" :scope="scope">
                                <template v-if="scope.row.warningRule">
                                    {{enums.warningRuleDatas[scope.row.warningRule.data]}}
                                    {{enums.warningRuleOperators[scope.row.warningRule.operator]}}
                                    {{scope.row.warningRule.threshold}}
                                </template>
                            </cv-table-column>
                            <cv-table-column label="状态" width="5em" :scope="scope">
                                <cv-tag v-if="scope.row.state" :c="'tag custom mini' | cMatch(null, enums.warningStates[scope.row.state].level)">
                                    {{enums.warningStates[scope.row.state].text}}
                                </cv-tag>
                            </cv-table-column>
                            <cv-table-column label="数据值" width="5em" :scope="scope">{{scope.row.dataValue}}</cv-table-column>
                            <cv-table-column label="最后预警时间" width="12em" :scope="scope">
                                <template v-if="scope.row.lastTime">
                                    {{scope.row.lastTime | format}}
                                </template>
                            </cv-table-column>
                            <cv-table-column label="开始预警时间" width="12em" :scope="scope">
                                <template v-if="scope.row.startTime">
                                    {{scope.row.startTime | format}}
                                </template>
                            </cv-table-column>
                        </template>
                    </cv-table>
                </div>
            </cv-form>
        </section><!-- 预警历史 -->
        <!-- 预警规则 -->
        <section v-if="$root.hasPermission(permissions.financing.product.warning.setting)" class="section">
            <div class="head">
                <span class="title">{{sectionWarningRuleTitle}}</span>
                <span class="operation">
                    <cv-button v-if="isNormalWarningSetting && $root.hasPermission(permissions.financing.product.warning.setting.add)" @click="showAddWarningSetting" c="link primary mini underline">新增关联</cv-button>
                    <cv-button v-if="isAddWarningSetting && $root.hasPermission(permissions.financing.product.warning.setting.add.rule)" @click="addWarningRule" c="link primary mini underline distant-x">新建规则</cv-button>
                    <cv-button v-if="isAddWarningSetting" @click="cancelAddWarningSetting" c="link primary mini underline">取消</cv-button>
                    <cv-button v-if="isAddWarningRule" @click="saveWarningRule" c="link primary mini underline distant-x">保存</cv-button>
                    <cv-button v-if="isAddWarningRule" @click="cancelAddWarningRule" c="link primary mini underline">取消</cv-button>
                </span>
            </div>
            <cv-form v-if="isNormalWarningSetting" :labelWidth="0" c="form primary medium distant-y">
                <div class="table-container">
                    <cv-table :data="warningSettings" c="table custom medium">
                        <template v-slot="scope">
                            <cv-table-column label="#" width="3em" :scope="scope">{{scope.index+1}}</cv-table-column>
                            <cv-table-column label="规则名称" width="15em" :scope="scope">
                                <template v-if="scope.row.warningRule">
                                    {{scope.row.warningRule.name}}
                                </template>
                            </cv-table-column>
                            <cv-table-column label="规则" width="20em" :scope="scope">
                                <template v-if="scope.row.warningRule">
                                    {{enums.warningRuleDatas[scope.row.warningRule.data]}}
                                    {{enums.warningRuleOperators[scope.row.warningRule.operator]}}
                                    {{scope.row.warningRule.threshold}}
                                </template>
                            </cv-table-column>
                            <cv-table-column label="状态" width="5em" :scope="scope">
                                <cv-tag v-if="scope.row.warningRule" :c="'tag custom mini' | cMatch(null, enums.warningRuleStates[scope.row.warningRule.state].level)">
                                    {{enums.warningRuleStates[scope.row.warningRule.state].text}}
                                </cv-tag>
                            </cv-table-column>
                            <cv-table-column label="操作" width="5em" :scope="scope">
                                <cv-button v-if="$root.hasPermission(permissions.financing.product.warning.setting.remove)" @click="removeWarningSetting(scope.index)" c="link primary mini underline">解除关联</cv-button>
                            </cv-table-column>
                        </template>
                    </cv-table>
                </div>
            </cv-form>
            <cv-form v-if="isAddWarningSetting" :labelWidth="0" c="form primary medium distant-y">
                <div class="table-container">
                    <cv-table :data="visibleWarningRules" c="table custom medium">
                        <template v-slot="scope">
                            <cv-table-column label="#" width="3em" :scope="scope">{{scope.index+1}}</cv-table-column>
                            <cv-table-column label="规则名称" width="15em" :scope="scope">{{scope.row.name}}</cv-table-column>
                            <cv-table-column label="规则" width="20em" :scope="scope">
                                {{enums.warningRuleDatas[scope.row.data]}}
                                {{enums.warningRuleOperators[scope.row.operator]}}
                                {{scope.row.threshold}}
                            </cv-table-column>
                            <cv-table-column label="状态" width="5em" :scope="scope">
                                <cv-tag v-if="scope.row.state" :c="'tag custom mini' | cMatch(null, enums.warningRuleStates[scope.row.state].level)">
                                    {{enums.warningRuleStates[scope.row.state].text}}
                                </cv-tag>
                            </cv-table-column>
                            <cv-table-column label="操作" width="5em" :scope="scope">
                                <cv-button @click="addWarningSetting(scope.index)" c="link primary mini uynderline">关联</cv-button>
                            </cv-table-column>
                        </template>
                    </cv-table>
                </div>
            </cv-form>
            <cv-form v-if="isAddWarningRule" label="名称" :labelWidth="2.5" c="form primary medium distant-y">
                <cv-input v-model="warningRule.name" c="input default medium" placeholder="请输入规则名称"></cv-input>
            </cv-form>
            <cv-form v-if="isAddWarningRule" label="规则" :labelWidth="2.5" c="form primary medium distant-y">
                <div class="warning-rule-rule">
                    <cv-select v-model="warningRule.data" :options="enums.warningRuleDatas" c="select default medium" placeholder="数据"></cv-select>
                    <cv-select v-model="warningRule.operator" :options="enums.warningRuleOperators" c="select default medium" placeholder="比较符"></cv-select>
                    <cv-input v-model.number="warningRule.threshold" c="input default medium" placeholder="阈值"></cv-input>
                </div>
            </cv-form>
        </section><!-- 预警规则 -->
    </cv-modal>
</template>

<script>
    import permissions from "../../js/permissions.js";
    
    export default {
        name: "ModalWarning",
        data() {
            return {
                permissions: permissions,
                visible: false,
                sections: {
                    warning: {
                        mode: "normal"
                    },
                    warningSetting: {
                        mode: "normal"
                    }
                },
                product: {
                    id: null,
                    name: null
                },
                warningRule: {
                    name: null,
                    data: null,
                    operator: null,
                    threshold: null
                },
                warnings: [],
                warningSettings: [],
                warningRules: [],
                enums: {
                    warningStates: {
                        WARNING: {
                            text: "预警中",
                            level: "warn"
                        },
                        FINISHED: {
                            text: "已结束",
                            level: "success"
                        }
                    },
                    warningRuleDatas: {
                        FUND_DRAWDOWN: "关联基金回撤率"
                    },
                    warningRuleOperators: {
                        GREATER_THAN: "大于",
                        GREATER_EQUALS: "大于等于",
                        EQUALS: "等于",
                        LESS_EQUALS: "小于等于",
                        LESS_THAN: "小于"
                    },
                    warningRuleStates: {
                        OPENED: {
                            text: "已启用",
                            level: "success"
                        },
                        CLOSED: {
                            text: "已停用",
                            level: "error"
                        }
                    }
                },
                unwatch: null
            };
        },
        computed: {
            isMoreWarning() {
                return this.sections.warning.mode == "more";
            },
            visibleWarnings() {
                if (!this.warnings || this.warnings.length == 0) {
                    return [];
                }
                
                if (this.isMoreWarning) {
                    return this.warnings;
                } else {
                    let warningWarnings = this.warnings.filter(warning => warning.state == "WARNING");
                    if (warningWarnings.length > 0) {
                        return warningWarnings;
                    } else {
                        return [this.warnings[0]];
                    }
                }
            },
            visibleWarningRules() {
                if (!this.warningRules || this.warningRules.length == 0) {
                    return [];
                }
                
                let warningSettingRuleIds = [];
                for (let i=0; i<this.warningSettings.length; i++) {
                    warningSettingRuleIds.push(this.warningSettings[i].warningRule.id);
                }
                
                let warningRules = [];
                for (let i=0; i<this.warningRules.length; i++) {
                    let warningRule = this.warningRules[i];
                    if (warningSettingRuleIds.indexOf(warningRule.id) >= 0) {
                        continue;
                    }
                    warningRules.push(warningRule);
                }
                
                return warningRules;
            },
            isNormalWarningSetting() {
                return this.sections.warningSetting.mode == "normal";
            },
            isAddWarningSetting() {
                return this.sections.warningSetting.mode == "add";
            },
            isAddWarningRule() {
                return this.sections.warningSetting.mode == "addRule";
            },
            sectionWarningRuleTitle() {
                if (this.isAddWarningSetting) {
                    return "关联预警规则";
                }
                if (this.isAddWarningRule) {
                    return "新建预警规则";
                }
                return "预警规则";
            }
        },
        methods: {
            async show(product) {
                this.product.id = product.id;
                this.product.name = product.name;
                this.visible = true;
                
                if (this.$root.hasPermission(permissions.financing.product.warning.show)) {
                    this.warnings = await this.$remotes.server.financing.warning.list(this.product.id);
                    
                    this.unwatch = this.$watch("warnings", newValue => {
                        let warningCount = newValue.filter(x => x.state == "WARNING").length;
                        this.$emit("changeWarningCount", warningCount);
                    }, {
                        immediate: true
                    });
                }
                
                if (this.$root.hasPermission(permissions.financing.product.warning.setting)) {
                    this.warningSettings = await this.$remotes.server.financing.warningSetting.list(this.product.id);
                }
                
                
                if (this.$root.hasPermission(permissions.financing.product.warning.setting.add)) {
                    this.warningRules = await this.$remotes.server.financing.warningRule.list(this.product.id);
                }
            },
            hide() {
                this.visible = false;
                this.clear();
            },
            clear() {
                if (this.unwatch) {
                    (this.unwatch)();
                }
                this.sections.warning.mode = "normal";
                this.sections.warningSetting.mode = "normal";
                this.product.id = null;
                this.product.name = null;
                this.clearWarningRule();
                this.warnings = [];
                this.warningSettings = [];
                this.warningRules = [];
            },
            clearWarningRule() {
                this.warningRule.name = null;
                this.warningRule.data = null;
                this.warningRule.operator = null;
                this.warningRule.threshold = null;
            },
            moreWarning() {
                this.sections.warning.mode = "more";
            },
            normalWarning() {
                this.sections.warning.mode = "normal";
            },
            showAddWarningSetting() {
                this.sections.warningSetting.mode = "add";
            },
            addWarningRule() {
                this.sections.warningSetting.mode = "addRule";
            },
            cancelAddWarningSetting() {
                this.sections.warningSetting.mode = "normal";
            },
            async removeWarningSetting(index) {
                let warningSetting = this.warningSettings[index];
                
                await this.$remotes.server.financing.warningSetting.remove({
                    id: warningSetting.id
                });
                this.warningSettings.splice(index, 1);
                
                this.warnings = await this.$remotes.server.financing.warning.list(this.product.id);
            },
            async addWarningSetting(index) {
                let warningRule = this.visibleWarningRules[index];
                let warningSetting = await this.$remotes.server.financing.warningSetting.add({
                    warningRule: {
                        id: warningRule.id
                    },
                    product: {
                        id: this.product.id
                    }
                });
                this.warningSettings.splice(0, 0, warningSetting);
                
                this.sections.warningSetting.mode = "normal";
                
                this.warnings = await this.$remotes.server.financing.warning.list(this.product.id);
            },
            async saveWarningRule() {
                let warningRule = await this.$remotes.server.financing.warningRule.add(this.warningRule);
                this.warningRules.splice(0, 0, warningRule);
                
                this.addWarningSetting(0);
                this.clearWarningRule();
            },
            cancelAddWarningRule() {
                this.sections.warningSetting.mode = "add";
                this.clearWarningRule();
            }
        }
    }
</script>

<style lang="scss">
    .modal.warning {
        .modal-content {
            width: 67em !important;
        }
    }
</style>

<style lang="scss" scoped>
    .section {
        margin-bottom: 1em;
        
        &:last-of-type {
            margin-bottom: 0;
        }
        
        .head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: .5em 0;
            border-bottom: solid 1px var(--color-border);
            
            .title {
                font-size: .9em;
            }
        }
        
        .form {
            .content {
                width: min-content;
            }
        }
        
        .timeline {
            margin-top: 1em;
        }
        .empty {
            margin-top: 1em;
            font-size: .9em;
            color: var(--color-primary-text);
        }
    }
    
    .table-container {
        width: 0;
        padding-bottom: 20px;
        overflow-x: auto;

        .table {
            width: 100%;
        }
    }
    
    .warning-rule-rule {
        width: 0;
        display: flex;
        flex-wrap: wrap;
        
        &>* {
            width: 33%;
            min-width: 100px;
            flex-grow: 1;
        }
    }
</style>